import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchContactsThunk } from "./thunks";
import { ManageContactsState, ContactsListResponse } from "./models";

const initialState: ManageContactsState = {
  contacts: {
    data: null,
    loading: false,
    error: null,
  },
};

const manageContactsSlice = createSlice({
  name: "manageContacts",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchContactsThunk.pending, (state) => {
        state.contacts.loading = true;
        state.contacts.error = null;
      })
      .addCase(fetchContactsThunk.fulfilled, (state, action: PayloadAction<ContactsListResponse>) => {
        state.contacts.data = action.payload;
        state.contacts.loading = false;
        state.contacts.error = null;
      })
      .addCase(fetchContactsThunk.rejected, (state, action) => {
        state.contacts.loading = false;
        state.contacts.error = action.payload as string;
      });
  },
});

export default manageContactsSlice.reducer;
